import React from "react";
import "../../styles/searchModal.scss";

const SearchModal = (props) => {
  return (
    <div className={`search-modal ${props.className}`}>
      <div className="modal-box">
        {props.options.map((item) => (
          <p
            className="option"
            onClick={() => {
              props.setOption(item.id);
              props.setPopoverVisible(false);
            }}
            key={item.id}
          >
            {item.display}
          </p>
        ))}
      </div>
    </div>
  );
};

export default SearchModal;
